import styled from 'styled-components';

export const ScrollWrapper = styled.div`
  overflow: scroll;
  height: 100%;
  z-index: 1;
`;

export const ListWrapper = styled(ScrollWrapper)`
  overflow: overlay;
`;
